import React from "react";
import { FadeComponent } from "../fadediv/FadeComponent";

export const RecordLuck = ({ show = true }) => {
  return (
    <FadeComponent show={show}>
      <div className="container stats-explained" style={{ paddingBottom: 100 }}>
        <h2>Record Luck</h2>

        <div className="gray-background-container" style={{ marginBottom: "50px" }}>
          <p className="text-template">
            <span
              style={{
                color: "#F26B0B",
                fontWeight: 700,
                fontSize: "16px",
                marginBottom: "14px",
              }}
            >
              Record Luck
            </span>{" "}
            = (SQ Win Percentage - Actual Win Percentage) *100
          </p>
          <p className="text-template">
            If you are projected to have more SQ wins than actual wins, you will have a positive record luck, and are
            due for positive regression.
          </p>
          <p className="text-template">
            Conversely, If you are projected to have less SQ wins than actual wins, you will have a negative record
            luck, and are due for negative regression.
          </p>

          <div className="row align-items-center ">
            <div className="box col-lg-12">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="w-50">
                        Rating
                        {/* <i className="fa fa-sort-desc" aria-hidden="true" /> */}
                      </th>
                      <th className="w-50">
                        Record Luck
                        {/* <i className="fa fa-sort-desc" aria-hidden="true" /> */}
                        <div className="tooltipCon">
                          <b className="d-block">Record Luck</b>
                          (SQ Win Percentage - Actual Win Percentage) *100. If positive, team is due for positive
                          regression. If negative, team is due for negative regression!
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Excellent</td>
                      <td>15 or more</td>
                    </tr>
                    <tr>
                      <td>Great</td>
                      <td>10</td>
                    </tr>
                    <tr>
                      <td>Above Average</td>
                      <td>5</td>
                    </tr>
                    <tr>
                      <td>Average</td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <td>Below Average</td>
                      <td>-5</td>
                    </tr>
                    <tr>
                      <td>Poor</td>
                      <td>-10</td>
                    </tr>
                    <tr>
                      <td>Awful</td>
                      <td>-15 or less</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FadeComponent>
  );
};
